import clsx from 'clsx'
import { PinIcon } from 'src/components'
import { LIVE_POST_IMG } from 'src/assets/svg'
import { LiveStatus } from '../../types'
import { LiveBadge } from '../liveBadge'
import { LiveHeader } from '../liveHeader'
import { LiveHighlightItemProps } from './liveHighlightItem.types'

import styles from './liveHighlightItem.module.css'

const LiveHighlightItem = ({ live }: LiveHighlightItemProps) => {
  return (
    <div className={clsx('_ml-5 _mr-4 _border-bottom', styles.box)}>
      <div className={clsx('_d-flex _align-items-baseline', styles.headerBox)}>
        <LiveHeader
          isHighlight={live?.status === LiveStatus.STARTED}
          liveDetail={{
            code: live.code,
            link: live.link ?? '',
            reportLink: live.reportLink ?? '',
            startAt: live.liveStartAt,
            status: live.status,
            thumbnail: live.largeThumbnailLink,
            watchCount: live.amountLead,
            description: live.description,
            enableVodPlayback: live.enableVodPlayback ?? false,
            endAt: live.completedAt,
            title: live.name
          }}
        />
        <picture className={clsx('_ml-auto _d-flex _align-items-center', styles.pin)}>
          <PinIcon />
        </picture>
      </div>
      <div className={clsx('_d-flex _align-items-end', styles.textBox)}>
        <div className={clsx('_d-flex _flex-1 _flex-column', styles.text)}>
          <p className={clsx('_p-0 _m-0 _font-weight-bold', styles.title)}>{live.name}</p>
          <p className={clsx('_p-0 _m-0', styles.desc)}>{live.description}</p>
        </div>

        <picture className={clsx('_position-relative _overflow-hidden', styles.imgBox)}>
          <img
            src={live.largeThumbnailLink ?? LIVE_POST_IMG}
            alt={live.name}
            className="_rounded"
            loading="lazy"
          />
          <LiveBadge className={styles.badge} />
        </picture>
      </div>
    </div>
  )
}

export default LiveHighlightItem
